import { useUrl } from "lib/site";
import LanguageEdit from "screens/components/LanguageEdit";

function PbaasAppLanguageEdit() {
    const returnUrl = useUrl()("PbaasAppLanguages");
    return <LanguageEdit defaultLocale="en" returnUrl={returnUrl} />;
}

export default PbaasAppLanguageEdit